import {
	includedPropList,
	includedT2PropList,
} from "../../../pages/activityBuilder/modules/livestockManagement/livestockManagement";
import type {
	LivestockManagementResponse,
	ModuleFull,
} from "../../../pages/activityBuilder/modules/livestockManagement/livestockManagementTypes";
import { FEModules } from "../../../utils/moduleList";
import { FEModulesObj } from "../../../utils/moduleList";
import { apiSlice, publicApiSlice, TagTypes } from "../../apiSlice";
import { createModuleGetApi, createModuleUpdateApi } from "./factories/createModuleApi";
import { prepareModulePayload, transformModuleResponse } from "./factories/moduleApiUtils";

// Define constants for the module
const MODULE_TYPE = "Livestock";
const TAG: TagTypes = "Livestock";
const TAG_DEFAULTS: TagTypes = "LivestockDefaults";
const ENDPOINT = FEModulesObj[FEModules.LivestockManagement].path;
const percentageProps = ["prp_percentage_t2"]; //its a t2 but displayed in t1

const transformResponse = (response: LivestockManagementResponse) => transformModuleResponse<LivestockManagementResponse, ModuleFull>({
	response,
	includedPropList,
	includedT2PropList,
	percentageProps
})
const livestocksApiSlice = createModuleGetApi<ModuleFull>({
	apiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformResponse,
})

const publicLivestocksApiSlice = createModuleGetApi<ModuleFull>({
	apiSlice: publicApiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformResponse,
})

export const {
	useGetLivestockQuery,
	useGetLivestockDefaultsQuery
} = livestocksApiSlice;

export const {
	useGetLivestockQuery: usePublicGetLivestockQuery,
	useGetLivestockDefaultsQuery: usePublicGetLivestockDefaultsQuery
} = publicLivestocksApiSlice;

const transformUpdatePayload = (data: ModuleFull, activityId: number) => prepareModulePayload({
	moduleData: data.module,
	tiertwoData: data.tiertwo,
	percentageProps,
	activityId
})

const mutationApiSlice = createModuleUpdateApi<ModuleFull, LivestockManagementResponse>({
	apiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformUpdatePayload,
})

export const {
	useUpdateLivestockMutation,
} = mutationApiSlice;
